import { gql } from "@apollo/client";

export const GET_ALL_MODALIDAD_VISITA = gql`
query GetAllModalidadVisita {
    allModalidadVisita{
            idModalidadVisita,
            nombre,
            abreviacion,
            activo
      }
}`;